import { type ClassValue, clsx } from 'clsx';
import { PressableStateCallbackType } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { format, isValid, parse } from "date-fns";
import { enGB } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function isTextChildren(
  children:
    | React.ReactNode
    | ((state: PressableStateCallbackType) => React.ReactNode)
) {
  return Array.isArray(children)
    ? children.every((child) => typeof child === 'string')
    : typeof children === 'string';
}

export function pluralise(count: number, singlarString: string, pluralString: string) {
  return count === 1 ? singlarString : pluralString
}

export const formatDate = (date: string | Date, dateFormat = "P") => {
  const newDate = typeof date === "string" ? new Date(date) : date;

  return isValid(newDate) ? format(newDate, dateFormat, { locale: enGB }) : "n/a";
};

function getOrdinalSuffix(day: number) {
  const j = day % 10,
    k = day % 100;
  if (j == 1 && k != 11) {
    return day + "st";
  }
  if (j == 2 && k != 12) {
    return day + "nd";
  }
  if (j == 3 && k != 13) {
    return day + "rd";
  }
  return day + "th";
}

export const formatDateForPrinting = (date: Date) => {

  const dayWithOrdinal = getOrdinalSuffix(date.getDate());
  const formattedDate = format(date, "eeee") + " " + dayWithOrdinal + " " + format(date, "MMMM yyyy");
  return formattedDate;
};

export const formatFriendlyShortDateTime = (date: string | Date) =>
  formatDate(date, "dd/MM/yyyy h:mma");

export const formatTime = (date: string | Date, timeFormat = "HH:mm:ss") => {
  const newDate = typeof date === "string" ? new Date(date) : date;

  return isValid(newDate) ? format(newDate, timeFormat, { locale: enGB }) : "n/a";
};


export const mapTimestampToHour = (date: Date): number => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Convert hours and minutes to a 24-hour format
  const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  // Combine hours and minutes and convert to integer
  const result = parseInt(`${formattedHours}${formattedMinutes}`, 10);

  return result;
};

export const timestampToNumber = (timestamp: string): number => {
  const [hours, minutes] = timestamp.split(":").map(Number);
  return hours * 100 + minutes;
}

export const addHoursToTimestamp = (timestamp: number, additionalHours: number): number => {
  let hours = Math.floor(timestamp / 100);
  const minutes = timestamp % 100;

  // Add additional hours
  hours += additionalHours;

  // Handle overflow (if the sum of hours exceeds 24)
  hours %= 24;

  return hours * 100 + minutes;
}
